
import teachers from '../../api/teachers'
import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'

// initial state
const state = {
    teachers: []
}

const actions = {
    [action_types.TEACHERS_LOAD] (context, {schoolId}) {
        teachers.getTeachers({schoolId}, loaded_teachers => {
            context.commit(mutation_types.TEACHERS_SET, {teachers: loaded_teachers});
        });
    },
}

// mutations
const mutations = {
    [mutation_types.TEACHERS_SET] (state, {teachers}) {
        state.teachers = teachers;
    },
}

export default {
    state,
    actions,
    mutations
}
